<footer class="footer" id="app-footer">
  <div class="row mainrow layout">
    <div class="col s12 m6 l6 xl6 align-left footer-content">
      <span class="spacing"><a class="white-text org-name"><span class="text">Phone Support: {{helpDeskPhone}}</span></a></span>
    </div>
    <div class="col s12 m6 l6 xl6 align-right footer-content">
      <span class="spacing"><a class="white-text org-name"><span class="text">{{selectedOrg}}</span></a></span>
    </div>
  </div>
</footer>
